import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import logo from './../../assets/images/green_shoppictcart_1484336527-1.png'
import { useFormik } from "formik";
import { object, string, ref } from 'yup';
import axios from "axios";
import { baseUrl } from './../../utils/baseUrl';
import { toast } from 'react-toastify';
import { Helmet, HelmetProvider } from 'react-helmet-async';





const Register = () => {

    const notify = (msg, type) => toast[type](msg);
    let navigate = useNavigate()
    const [errorMessage, setErrorMessage] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    let validationSchema = object({
        userName: string().min(5).max(32).required(),
        email: string().email().required(),
        phone: string().matches(/^(\+201|01|00201)[0-2,5]{1}[0-9]{8}/).required(),
        password: string().matches(/^(?=.*[A-Za-z])(?=.*\d)*([@$!%*#?&])*[A-Za-z\d@$!%*#?&.]{6,32}$/, "password must match the pattern").required(),
        cPass: string().oneOf([ref('password')], "password and re password must be the same").required(),
        DOB: string().required(),
    });

    let registerFormik = useFormik({
        initialValues: {
            userName: '',
            email: '',
            phone: '',
            password: '',
            cPass: '',
            DOB: '',
        },
        validationSchema,
        onSubmit: (values) => {
            setIsLoading(true)
            axios.post(`${baseUrl}/auth/signup`, values).then((response) => {
                if (response.status === 201) {
                    setIsLoading(false)
                    notify("Sign Up success", "success")
                    navigate('/signin')
                }
            }).catch((error) => {
                if (error.response) {
                    setIsLoading(false)
                    setErrorMessage(error.response.data.error)
                    notify(error.response.data.error, "error")
                }
            })
        }
    })

    return (
        <HelmetProvider>
            <Helmet>
                <title>FreshCart | SignUp</title>
            </Helmet>
            <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8 ">
                <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                    <img className="mx-auto h-16 w-auto"
                        src={logo}
                        alt="Fresh Cart"
                    />
                    <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
                        Sign up new account
                    </h2>
                </div>

                <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-xl">
                    {errorMessage ? <div className="bg-red-500 py-2 px-3 w-full text-gray-50 rounded my-2">{errorMessage}</div> : ""}
                    <form className="space-y-6" onSubmit={registerFormik.handleSubmit}>
                        <div>
                            <label htmlFor="userName" className="block text-sm font-medium leading-6 text-gray-900">
                                User Name
                            </label>
                            <div className="mt-2">
                                <input onBlur={registerFormik.handleBlur}
                                    onChange={registerFormik.handleChange}
                                    value={registerFormik.values.userName} id="userName" name="userName" type="userName"
                                    className="block w-full rounded-md border border-gray-500 px-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset  sm:text-sm sm:leading-6"
                                />
                            </div>
                            {registerFormik.errors.userName && registerFormik.touched.userName ? (
                                <div className=" text-red-700 m-1">
                                    {registerFormik.errors.userName}
                                </div>
                            ) : (
                                ""
                            )}
                        </div>
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                                Email address
                            </label>
                            <div className="mt-2">
                                <input
                                    onBlur={registerFormik.handleBlur}
                                    value={registerFormik.values.email}
                                    onChange={registerFormik.handleChange} id="email" name="email" type="email"
                                    className="block w-full rounded-md border border-gray-500 px-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset  sm:text-sm sm:leading-6"
                                />
                            </div>
                            {registerFormik.errors.email && registerFormik.touched.email ?
                                <div className=" py-1 text-red-700 my-2">{registerFormik.errors.email}</div> : ""}
                        </div>
                        <div>
                            <div className="flex items-center justify-between mt-2">
                                <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
                                    Password
                                </label>
                            </div>
                            <div className="mt-2">
                                <input
                                    onBlur={registerFormik.handleBlur}
                                    value={registerFormik.values.password}
                                    onChange={registerFormik.handleChange}
                                    id="password"
                                    name="password"
                                    type="password"
                                    className="block w-full rounded-md border border-gray-500 px-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset  sm:text-sm sm:leading-6"
                                />
                            </div>
                            {registerFormik.errors.password && registerFormik.touched.password ?
                                <div className=" py-1 text-red-600 my-2">{registerFormik.errors.password}</div> : ""}
                        </div>
                        <div>
                            <div className="flex items-center justify-between mt-2">
                                <label htmlFor="cPass" className="block text-sm font-medium leading-6 text-gray-900">
                                    Confirm Password
                                </label>
                            </div>
                            <div className="mt-2">
                                <input
                                    onBlur={registerFormik.handleBlur}
                                    value={registerFormik.values.cPass}
                                    onChange={registerFormik.handleChange}
                                    id="cPass"
                                    name="cPass"
                                    type="password"
                                    className="block w-full rounded-md border border-gray-500 px-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset  sm:text-sm sm:leading-6"
                                />
                            </div>
                            {registerFormik.errors.cPass && registerFormik.touched.cPass ?
                                <div className=" py-1 text-red-600 my-2">{registerFormik.errors.cPass}</div> : ""}
                        </div>

                        <div className="grid grid-cols-2 gap-2">
                            <div>
                                <label htmlFor="phone" className="block text-sm font-medium leading-6 text-gray-900">
                                    Phone
                                </label>
                                <div>
                                    <input
                                        onBlur={registerFormik.handleBlur}
                                        onChange={registerFormik.handleChange}
                                        value={registerFormik.values.phone} id="phone" name="phone" type="text"
                                        className="block w-full rounded-md border border-gray-500 px-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset  sm:text-sm sm:leading-6"
                                    />
                                </div>
                                {registerFormik.errors.phone && registerFormik.touched.phone ?
                                    <div className=" py-1 text-red-600 my-2">{registerFormik.errors.phone}</div> : ""}
                            </div>
                            <div>
                                <label htmlFor="DOB" className="block text-sm font-medium leading-6 text-gray-900">
                                    Date of Birth
                                </label>
                                <div className="">
                                    <input
                                        onBlur={registerFormik.handleBlur}
                                        onChange={registerFormik.handleChange}
                                        value={registerFormik.values.DOB} id="DOB" name="DOB" type="date"
                                        className="block w-full rounded-md border border-gray-500 px-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset  sm:text-sm sm:leading-6"
                                    />
                                </div>
                                {registerFormik.errors.DOB && registerFormik.touched.DOB ?
                                    <div className=" py-1 text-red-600 my-2">{registerFormik.errors.DOB}</div> : ""}
                            </div>
                        </div>
                        <div>
                            <button
                                type="submit" disabled={registerFormik.isValid && registerFormik.dirty && !isLoading ? false : true}
                                className={"bg-green-600 hover:bg-green-500 text-gray-50 rounded my-2 py-2 px-5 disabled:bg-green-600 disabled:opacity-40"}>{isLoading ? <i className="fas fa-spinner fa-spin"></i> : 'Sign Up'}
                            </button>
                        </div>
                    </form>

                    <p className="mt-10 text-center text-sm text-gray-500">
                        Already User?{' '}
                        <Link to="/signin" className="font-semibold leading-6 text-green-600 hover:text-green-500">
                            Sign In
                        </Link>
                    </p>
                </div >
            </div >
        </HelmetProvider>
    )
}

export default Register